<template>
    <div>
        <nav
            class="footer"
            :class="isMobile ? 'footer-sm' : 'footer-lg'"
            v-if="$route.path !== '/maung-fb' && $route.path !== '/body-fb' && $route.path !== '/correct-score-fb' && $route.path !== '/1x2-fb'"
            aria-label="Main navigation"
        >
            <div class="footer-nav-inner">
                <ul class="nav nav-footer footer-nav-list">
                        <li
                            class="nav-item"
                            @click="$router.push('/home')"
                            :aria-current="linkIsActive('/home') ? 'page' : null"
                        >
                            <div class="d-flex flex-column banking-icons" :class="{ 'is-active': linkIsActive('/home') }">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    :src="linkIsActive('/home') ? 'https://storage.googleapis.com/spacetech2/mdl/home1.png' : 'https://storage.googleapis.com/spacetech2/mdl/home.png'"
                                    alt=""
                                >
                                <span :class="linkIsActive('/home') ? 'active' : ''" class="mx-auto footer-label footer-text">
                                    {{$t('footer.home')}}
                                </span>
                            </div>
                        </li>
                        
                        <!-- <li
                            class="nav-item"
                            @click="openModal()"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" src="/build/assets/img/icons/Download.png" style="width: 18px; height: 18px" alt="">
                                <div class="mx-auto pt-1 text-sm" style="color: #a486ea;">
                                    {{
                                        $store.state.language === "en"
                                            ? "Download"
                                            : "ဒေါင်းလုတ်"
                                    }}
                                </div>
                            </div>
                        </li> -->
                        <!-- :class="linkIsActive('/deposit') ? 'active' : ''" -->
 
                        <!-- <li
                            class="nav-item"
                            @click="$router.push('/history')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" :src="linkIsActive('/history') ? 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/salmon/icons/trasnsfer.png-1.png' : 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/salmon/icons/trasnsfer.png'" style="width: auto; height: 1.5rem;" alt="">
                                <div :class="linkIsActive('/history') ? 'active' : ''" class="mx-auto pt-1 text-sm footer-text" style="color: #ccc;">
                                    {{$t('setting.transaction')}}
                                </div>
                            </div>
                        </li> -->
                        <!-- <li
                            class="nav-item"
                        >
                            <a href="#">
                                <div class="d-flex flex-column banking-icons">
                                    <img class="mx-auto" src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/telegram%20(2).png" style="width: auto; height: 1.5rem;" alt="">
                                    <div :class="linkIsActive('/home') ? 'active' : ''" class="mx-auto pt-1 text-sm footer-text" style="color: #ccc;">
                                        {{$t('setting.customer_service')}}
                                    </div>
                                </div>
                            </a>
                        </li> -->
                        <li
                            class="nav-item"
                        >
                            <div
                                class="d-flex flex-column banking-icons footer-tap-target"
                                :class="{ 'is-active': isWalletRoute }"
                                id="popover-target-1"
                            >
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/mdl/wallet.png"
                                    alt=""
                                >
                                <span :class="isWalletRoute ? 'active' : ''" class="mx-auto footer-label footer-text">
                                    {{$t('home.wallet')}}
                                </span>
                            </div>
                            <b-popover
                                target="popover-target-1"
                                placement="top"
                                ref="popover"
                            >
                                <template #title>{{ $t('home.please_choose_one') }}</template>
                                <div class="d-flex justify-content-between footer-wallet-actions">
                                    <button
                                        type="button"
                                        class="btn footer-wallet-btn footer-wallet-btn--deposit text-dark"
                                        @click="$router.push('/deposit'), onClose()"
                                    >
                                        {{ $t('setting.deposit') }}
                                    </button>
                                    <button
                                        type="button"
                                        class="btn footer-wallet-btn footer-wallet-btn--withdraw"
                                        @click="$router.push('/withdraw'), onClose()"
                                    >
                                        {{ $t('setting.withdraw') }}
                                    </button>
                                </div>
                            </b-popover>
                        </li>

                        <li class="nav-item">
                            <a
                                class="footer-external-link"
                                href="viber://contact?number=%2B959897141336"
                                rel="noopener noreferrer"
                            >
                                <div class="d-flex flex-column banking-icons">
                                    <img
                                        class="mx-auto footer-nav-icon"
                                        src="https://storage.googleapis.com/spacetech2/mdl/customer%20service.png"
                                        alt=""
                                    >
                                    <span :class="linkIsActive('/live-chat') ? 'active' : ''" class="mx-auto footer-label footer-text">
                                        {{$t('home.live_chat')}}
                                    </span>
                                </div>
                            </a>
                        </li>

                        <li
                            class="nav-item"
                            @click="$router.push('/setting')"
                            :aria-current="linkIsActive('/setting') ? 'page' : null"
                        >
                            <div class="d-flex flex-column banking-icons" :class="{ 'is-active': linkIsActive('/setting') }">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    :src="linkIsActive('/setting') ? 'https://storage.googleapis.com/spacetech2/mdl/account1.png' : 'https://storage.googleapis.com/spacetech2/mdl/account.png'"
                                    alt=""
                                >
                                <span :class="linkIsActive('/setting') ? 'active' : ''" class="mx-auto footer-label footer-text">
                                    {{$t('footer.profile')}}
                                </span>
                            </div>
                        </li>
                    </ul>
            </div>
        </nav>
    </div>
</template>
<script>
export default {
  data() {
    return {
      is_live: false,
      isMobile: false,
    };
  },
  computed: {
    isWalletRoute() {
      const p = this.$route.path;
      return p === '/deposit' || p === '/withdraw';
    },
  },
  methods: {
    onClose() {
        this.$refs.popover.$emit('close')
    },
    closeModal() {
      $('#download-modal').modal('hide');
    },
    openModal() {
      $('#download-modal').modal('show');
    },
    /* example link = '/settings' */
    linkIsActive(link) {
      return this.$route.path === link;
    },
    updateIsMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    async fetchFootballLive() {
      try {
        const res = await axios.get('/football-lives');
        this.is_live = res.data.data[0].is_live;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.updateIsMobile();
    window.addEventListener('resize', this.updateIsMobile, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
};
</script>
<style scoped>
.footer-text.active,
.footer-label.active {
    color: #5c98ff !important;
}
.footer-label {
    color: #8b95a8;
    font-size: 0.65625rem;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 0.12rem;
    max-width: 100%;
    padding: 0 0.15rem;
    text-align: center;
    transition: color 0.15s ease, transform 0.12s ease;
    -webkit-tap-highlight-color: transparent;
}
.footer-nav-icon {
    height: 1.35rem;
    width: auto;
    display: block;
    transition: transform 0.15s ease;
}
.footer-nav-inner {
    max-width: 100%;
    margin: 0 auto;
}
.footer-nav-list {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0 0.35rem;
    list-style: none;
}
.footer-nav-list .nav-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
}
.banking-icons {
    align-items: center;
    border-radius: 9px;
    box-sizing: border-box;
    justify-content: center;
    min-height: 2.45rem;
    padding: 0.22rem 0.22rem 0.16rem;
    transition: background 0.18s ease, box-shadow 0.18s ease;
    width: 100%;
    max-width: 4.35rem;
}
.banking-icons.is-active {
    background: rgba(92, 152, 255, 0.14);
}
.footer-tap-target {
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.nav-item:active .footer-nav-icon {
    transform: scale(0.94);
}
.nav-item:active .banking-icons:not(.is-active) {
    background: rgba(255, 255, 255, 0.04);
}
.footer-external-link {
    align-items: center;
    color: inherit;
    display: flex;
    justify-content: center;
    text-decoration: none;
    width: 100%;
    -webkit-tap-highlight-color: transparent;
}
.footer-external-link:hover {
    color: inherit;
    text-decoration: none;
}
.footer-wallet-actions {
    gap: 0.5rem;
}
.footer-wallet-btn {
    border: none;
    border-radius: 8px;
    flex: 1;
    font-size: 0.8125rem;
    font-weight: 600;
    min-height: 2.5rem;
    padding: 0.4rem 0.5rem;
    transition: filter 0.15s ease, transform 0.1s ease;
}
.footer-wallet-btn:active {
    transform: scale(0.98);
}
.footer-wallet-btn--deposit {
    background: linear-gradient(180deg, #7dd87a 0%, #5cb85c 100%);
    box-shadow: 0 2px 8px rgba(92, 184, 92, 0.35);
}
.footer-wallet-btn--withdraw {
    background: #2a2d36;
    border: none;
    color: #e8eaef;
}
.modal-content {
    border: 2px solid #714dc7;
}
td .fa-trash {
    color: red;
}
.modal-cross {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    padding-top: 3px;
    margin-left: auto;
    color: white;
    cursor: pointer;
    margin-right: -9px;
    margin-top: -9px;
    background: #714dc7;
}
.bet-container {
    position: fixed;
    bottom: 0;
    margin-bottom: 50px;
    width: 50px;
    left: 5px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.25em;
    color: white;
    z-index: 100;
    visibility: visible;
    opacity: 1;
}
.nav-item {
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    color: #93a1c0 !important;
    min-width: 0;
    user-select: none;
}
.footer {
    background: #1d1f26;
    border-top: none;
    bottom: 0;
    box-shadow: 0 -6px 20px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    left: 0;
    padding: 0.16rem 0 calc(0.22rem + env(safe-area-inset-bottom, 0px));
    right: 0;
    width: 100%;
    z-index: 1030;
}
.footer-sm {
    position: fixed;
}
.footer-lg {
    position: absolute;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);
}
</style>
